var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreFiltres", {
        attrs: { filtres: _vm.filtres },
        on: {
          "appliquer-filtre": function($event) {
            return _vm.appliquerFiltre($event)
          }
        }
      }),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-center-center" }, [
      _c(
        "div",
        { staticClass: "card col-12 col-xl-10 col-xxl-8 height-responsive" },
        [
          _c("div", { staticClass: "card-header" }, [
            _vm._v("Stock - Documentation ")
          ]),
          _c(
            "div",
            {
              staticClass:
                "card-container height-responsive-body height-responsive-1b"
            },
            [
              _c("section", { attrs: { id: "sectionStock" } }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      'Une fois qu\'une commande est réceptionnée, vous avez la possibilité de transférer les produits dans votre stock à partir du menu "Commandes".'
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'Vous pouvez également ajouter des produits manuellement directement depuis le menu "Stock".'
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionInfoStock" } }, [
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Les produits en stock sont affichés par zone de stockage puis par ingrédient."
                    )
                  ]),
                  _c("p")
                ])
              ]),
              _c("section", { attrs: { id: "sectionAjouterStock" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Ajouter du stock")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Pour ajouter du stock, vous avez deux options de recherche :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [_vm._v("Par désignation produit.")]),
                    _c("li", [_vm._v("Par référence.")])
                  ]),
                  _c("p", [
                    _vm._v(
                      "Une fois votre désignation ou référence notée, selectionner l'ingrédient correspondant."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'Par exemple, on souhaite ajouter un "Steak Haché de 100Gr de 15%MG - Viande Française" à notre stock.'
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      'On indique la désignation "steak", l\'ingrédient le plus proche de notre produit est le "Boeuf Steack Hache", cependant plusieurs produits sont rattachés à cet ingrédient.'
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/stock/stock/ajoutStockExemple.png"),
                        alt: "Illustration fenêtre ajouter en stock exemple"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "La 3ème colonne \"Produit\", indique les produits que l'on va trouver si l'on sélectionne une ligne."
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/stock/stock/ajoutStockExemple1.png"),
                        alt: "Illustration fenêtre ajouter en stock exemple"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Une fois la ligne ingrédient choisit la liste des produits s'affichent, pour sélectionner un produit, cliquez simplement sur la ligne :"
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Cela ouvre des champs à remplir pour ajouter l'article dans le stock, deux champs sont obligatoires pour l'enregistrement:"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v(
                        "Indiquer si c'est une entrée de marchandise ou une régularisation."
                      )
                    ]),
                    _c("li", [_vm._v("La quantité.")])
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c(
                      "table",
                      { staticClass: "table table-bordered text-center" },
                      [
                        _c("thead", { staticClass: "table-header" }, [
                          _c("tr", [
                            _c("th", [_vm._v("Boutons")]),
                            _c("th", { staticClass: "aligner-gauche" }, [
                              _vm._v("Signification")
                            ])
                          ])
                        ]),
                        _c("tbody", [
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn btn-primary btn-secondary",
                                  attrs: {
                                    title: "Fiche technique",
                                    type: "button"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-book-open" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Permet d'accéder à la fiche technique.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c("i", {
                                staticClass: "fas fa-info-circle cursor-pointer"
                              })
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Permet d'accéder aux mouvements du produit."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    title: "Retirer une quantité"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-minus" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v("Dans la colonne quantité, permet "),
                              _c(
                                "a",
                                {
                                  attrs: { href: "#sectionModificationStock" }
                                },
                                [_vm._v("d'enlever du stock")]
                              ),
                              _vm._v(" pour un produit.")
                            ])
                          ]),
                          _c("tr", [
                            _c("td", [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  attrs: {
                                    type: "button",
                                    title: "Ajouter une quantité"
                                  }
                                },
                                [_c("i", { staticClass: "fas fa-plus" })]
                              )
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Dans la colonne quantité, permet d'ajouter du stock pour un produit."
                              )
                            ])
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "warning" }, [
                              _c("i", {
                                staticClass: "fas fa-exclamation-triangle mr-2"
                              }),
                              _vm._v("PRODUIT SANS INGRÉDIENT")
                            ]),
                            _c("td", { staticClass: "aligner-gauche" }, [
                              _vm._v(
                                "Indique que les produits listés n'ont pas d'ingrédient rattaché. il faut affecter un ingrédient au produit hors marché à partir du menu Commandes -> Produits hors marché"
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionModificationStock" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Modifier du stock")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Si vous souhaitez modifier la quantité d'un produit, vous devez sélectionner les boutons en fin de ligne du produit concerné."
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: { type: "button", title: "Retirer une quantité" }
                      },
                      [_c("i", { staticClass: "fas fa-minus" })]
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Le nom du produit en question s'affiche en en-tête de la fenêtre."
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/stock/stock/stockRetireQuantite.png"),
                        alt:
                          "Illustration fenêtre modifier la quantité d'un produit"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Une fois modifié et enregistré, cela met à jour le total du stock."
                    )
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionStockAnterieur" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Consulter les stocks antérieurs")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Sur le calendrier, vous avez la possibilité de consulter les stocks antérieurs."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Un bouton jaune se présente en haut à gauche pour indiquer que vous ne consultez pas le stock du jour actuel. Il vous offre la possibilité de retourner vers le stock en cours."
                    )
                  ]),
                  _c("div", { staticClass: "flex-center-center mb-3" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("img", {
                        staticClass: "border-black border-rounded w-100",
                        attrs: {
                          src: require("../../assets/images/documentation/stock/stock/stockBtnJaune.png"),
                          alt: "Illustration bouton stock à jour"
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionInventaire" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Inventaire")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Vous avez la possibilité de procéder à un inventaire, celui-ci inclut les données du stock."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dans un premier temps, vous devez indiquer la date de l'inventaire, qui ne peut pas être antérieure au dernier mouvement du stock réel."
                    )
                  ]),
                  _c("p", [
                    _vm._v("Les produits sont affichés par zone de stockage.")
                  ]),
                  _c("p", [
                    _vm._v(
                      "Au cours de cet inventaire, vous avez la possibilité :"
                    )
                  ]),
                  _c("ul", { staticClass: "puces" }, [
                    _c("li", [
                      _vm._v("D'ajuster les quantités des produits existants.")
                    ]),
                    _c("li", [_vm._v("Intégrer de nouveaux produits.")])
                  ]),
                  _c("p", [
                    _vm._v(
                      'Dès que vous modifiez une quantité, la case "vérifié" est automatiquement cochée. '
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous pouvez également exporter votre inventaire à tout moment au cours de ce processus. Vous trouverez dans le second onglet la synthèse par zone de stockage"
                    )
                  ]),
                  _c("div", { staticClass: "h6 important" }, [
                    _c("p", [
                      _vm._v(
                        "Pendant la réalisation d'un inventaire, toutes les modifications relatives au stock et à la réception des commandes sont verrouillées."
                      )
                    ])
                  ])
                ])
              ]),
              _c("section", { attrs: { id: "sectionMouvements" } }, [
                _c("div", { staticClass: "header header-tertiary" }, [
                  _vm._v("Mouvements")
                ]),
                _c("div", { staticClass: "card-body" }, [
                  _c("p", [
                    _vm._v(
                      "Pour visionner l'historique de vos produits, vous devez indiquer une période."
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "La liste complète de vos produits s'affichera en fonction de cette période."
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/stock/mouvements/jauneMouvement.png"),
                        alt: "Illustration bouton stock à jour"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Si vous souhaitez plus de détails sur un produit en particulier, cliquez sur le bouton "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn-sm btn btn-primary",
                        attrs: { type: "button" }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-info-circle cursor-pointer"
                        })
                      ]
                    ),
                    _vm._v(" situé en bout de ligne.")
                  ]),
                  _c("p", [
                    _vm._v(
                      'Si une cellule dans la colonne "Quantité au ..." est colorée en jaune, cela indique une incohérence dans les mouvements de ce produit.'
                    )
                  ]),
                  _c("div", { staticClass: "container mb-3" }, [
                    _c("img", {
                      staticClass: "border-black border-rounded w-100",
                      attrs: {
                        src: require("../../assets/images/documentation/stock/mouvements/detailMouvements.png"),
                        alt: "Illustration bouton stock à jour"
                      }
                    })
                  ]),
                  _c("p", [
                    _vm._v(
                      "Vous avez également la possibilité d'exporter ces données en cliquant sur le bouton : "
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn btn-secondary btn-primary",
                        attrs: { type: "button" }
                      },
                      [_vm._v("Exporter")]
                    )
                  ]),
                  _c("p", [
                    _vm._v(
                      "Dans cet Excel, vous trouverez quatre onglets : Complet, Volume, HT et TTC."
                    )
                  ])
                ])
              ])
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }